import React, { Component } from 'react';

export class NewRelease extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return <div>Release version: {process.env.BUILD_VERSION}</div>;
  }
}

export default NewRelease;
